import { wrap } from 'svelte-spa-router/wrap'
import { needLogin, isLogin } from './auth'

import LoginView from './users/view.login.svelte'
import HomeView from './home/view.home.svelte'
import OrdersView from './orders/view.orders.svelte'
import OrderView from './orders/view.order.svelte'
import AutomaticView from './orders/view.automatic.svelte'
import MovementsView from './movements/view.movements.svelte'
import ShipmentsView from './shipments/view.shipments.svelte'
import PickupsView from './pickups/view.pickups.svelte'
import QuotationsView from './quotations/view.quotations.svelte'
import FacturamaView from './facturama/view.facturama.svelte'
import SettingsView from './settings/view.settings.svelte'
import TicketsView from './tickets/view.tickets.svelte'
import TrackingsView from './trackings/view.trackings.svelte'
import OrdersLinksView from './orders.links/view.orders.links.svelte'
import ShopifyErrorView from './integrations/view.shopify.error.svelte'
import PaymentsView from './payments/view.payments.svelte'
import AccountsView from './accounts/view.accounts.svelte'
import IntegrationsView from './integrations/view.integrations.svelte'
import ChargesView from './charges/view.charges.svelte'
import ShipmentReferenceView from './shipments/view.shipments.references.svelte'
import SettingsAccountView from './settings/view.settings.account.svelte'
import TiendanubeInstallView from './tiendanube/view.tiendanube.install.svelte'

const routes = {

    '/': wrap({
        component: LoginView,
        conditions: [needLogin]
    }),

    '/home': wrap({
        component: HomeView,
        conditions: [isLogin]
    }),

    '/orders': wrap({
        component: OrdersView,
        conditions: [isLogin]
    }),

    '/order/:default?': wrap({
        component: OrderView,
        conditions: [isLogin]
    }),

    '/automatic': wrap({
        component: AutomaticView,
        conditions: [isLogin]
    }),

    '/payments': wrap({
        component: PaymentsView,
        conditions: [isLogin]
    }),

    '/movements': wrap({
        component: MovementsView,
        conditions: [isLogin]
    }),

    '/shipments': wrap({
        component: ShipmentsView,
        conditions: [isLogin]
    }),

    '/pickups': wrap({
        component: PickupsView,
        conditions: [isLogin]
    }),

    '/quotations': wrap({
        component: QuotationsView,
        conditions: [isLogin]
    }),

    '/invoices': wrap({
        component: FacturamaView,
        conditions: [isLogin]
    }),

    '/settings/:tab?': wrap({
        component: SettingsView,
        conditions: [isLogin]
    }),

    '/tracing': wrap({
        component: SettingsAccountView,
        conditions: [isLogin]
    }),

    '/tickets': wrap({
        component: TicketsView,
        conditions: [isLogin]
    }),

    '/accounts': wrap({
        component: AccountsView,
        conditions: [isLogin]
    }),

    '/integrations': wrap({
        component: IntegrationsView,
        conditions: [isLogin]
    }),

    '/charges': wrap({
        component: ChargesView,
        conditions: [isLogin]
    }),

    '/trackings/:shipmentCode': wrap({
        component: TrackingsView
    }),

    '/orderslinks/:ordersLinksId': wrap({
        component: OrdersLinksView
    }),

    '/tracking/:shipmentCode': wrap({
        component: TrackingsView
    }),

    '/shipments/:shipmentCode/references': wrap({
        component: ShipmentReferenceView
    }),

    '/shopify/error': wrap({
        component: ShopifyErrorView
    }),

    '/tiendanube/install': wrap({
        component: TiendanubeInstallView
    }),
}

export {routes}